import api from './api';

export function tc_left(value, max) {
    if (!value)
        return "";
    if (value.length > max) {
        return left(value, max) + '…';
    } else {
        return value;
    }
}

export function left(str, num)
{
    return str.substring(0,num)
}

export function hc(value) {
    if (!value)
        return '';
    return value.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
}

export function html_filter(value) {
    const div = document.createElement("div");
    div.innerHTML = value;
    return div.textContent || div.innerText || "";
}

export function delete_alert(url, field, sn, ti, success_callback = null) {
    swal({
            title: "確認刪除",
            text: "確認刪除此筆：" + ti,
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "確認刪除!",
            closeOnConfirm: false
        },
        function () {
            let data = {};
            data[field] = sn;
            api.post(url, data).then(function (response) {

                if (response.data.sResult == true) {
                    swal({
                            title: "Deleted",
                            text: ti + "已成功刪除!",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonClass: "btn-success",
                            confirmButtonText: "OK",
                            closeOnConfirm: false
                        },
                        function () {
                            if(success_callback)
                            {
                                success_callback();
                            }
                            swal.close();

                        });
                } else {
                    swal({
                        title: "Error",
                        text: response.data.msg,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: false
                    })
                }
            })
        })
}
